////////////////////////////////////////////////////////////////////////////////
//                                                                            //
//  IRONSIDE - Public Website GUI                                             //
//                                                                            //
//  Version: 1.0.1                                                            //
//  Summary: prefers-reduced-motion hook (1.0.1.md NOTE 8)                   //
//                                                                            //
////////////////////////////////////////////////////////////////////////////////

import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

/** Tracks the OS/browser `prefers-reduced-motion` setting for the lifetime of the
 * component. A genuine subscription to an external system (the media query), so an
 * effect is the correct tool here — not a case of copying a prop into state. Every
 * animated component (framer-motion) MUST read this before choosing a transition;
 * a construction site's WHS culture and an accessibility obligation point the same
 * way (1.0.1.md NOTE 8). */
export function useReducedMotion (): boolean {
  const [reduced, setReduced] = useState(() =>
    typeof window === 'undefined' ? false : window.matchMedia(QUERY).matches,
  );

  useEffect(() => {
    const mql = window.matchMedia(QUERY);
    const onChange = (event: MediaQueryListEvent) => setReduced(event.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return reduced;
}
